import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logout-callback',
  templateUrl: './logout-callback.component.html',
  styleUrls: ['./logout-callback.component.scss']
})
export class LogoutCallbackComponent implements OnInit {
  
  public whitelabel: string
  public whitelabelURL: string = 'https://cubosgeneralstorage.blob.core.windows.net/whitelabel-storage/'

  currentYearLong(): number {
    return new Date().getFullYear();
  }

  constructor() { }

  ngOnInit(): void {
  }
  
  ngAfterViewInit() {
    this.whitelabel = localStorage.getItem('whitelabel')
  }

}
